<template>
  <subpage-shell
    v-if="slug"
    :eyebrow="trans.get('landing.subpages.dating_city.eyebrow', { city: cityTitle })"
    :title-prefix="trans.get('landing.subpages.dating_city.title_prefix', { city: cityTitle })"
    :title-grad="trans.get('landing.subpages.dating_city.title_grad', { city: cityTitle })"
    :title-suffix="trans.get('landing.subpages.dating_city.title_suffix', { city: cityTitle })"
    :cta-lede="trans.get('landing.subpages_shared.cta_lede_quiz_match')"
  >
    <main class="prose">
      <p>{{ trans.get(cityKey('intro.p1')) }}</p>
      <p>{{ trans.get(cityKey('intro.p2')) }}</p>
      <p>{{ trans.get(cityKey('intro.p3')) }}</p>

      <div class="inline-cta">
        <div class="ic-txt">
          <strong>{{
            trans.get('landing.subpages.dating_city.inline_ready_strong', { city: cityTitle })
          }}</strong>
          <span>{{
            trans.get('landing.subpages.dating_city.inline_ready_text', { city: cityTitle })
          }}</span>
        </div>
        <button
          type="button"
          class="ic-btn"
          @click="openSignup"
        >
          {{ trans.get('landing.subpages_shared.cta_start_free') }}
          <span aria-hidden="true">→</span>
        </button>
      </div>

      <h2>{{ trans.get(cityKey('sectionTitle')) }}</h2>
      <p>{{ trans.get(cityKey('section.p1')) }}</p>
      <p v-if="hasSectionP2">{{ trans.get(cityKey('section.p2')) }}</p>

      <h3>{{ trans.get(cityKey('neighborhoodsTitle')) }}</h3>
      <p>{{ trans.get(cityKey('neighborhoods')) }}</p>

      <h3>{{ trans.get(cityKey('themesTitle')) }}</h3>
      <ul>
        <li>{{ trans.get(cityKey('themes.t1')) }}</li>
        <li>{{ trans.get(cityKey('themes.t2')) }}</li>
        <li>{{ trans.get(cityKey('themes.t3')) }}</li>
        <li>{{ trans.get(cityKey('themes.t4')) }}</li>
      </ul>

      <div class="inline-cta inline-cta--2">
        <div class="ic-txt">
          <strong>{{
            trans.get('landing.subpages.dating_city.inline_ready_2_strong', { city: cityTitle })
          }}</strong>
          <span>{{
            trans.get('landing.subpages.dating_city.inline_ready_2_text', { city: cityTitle })
          }}</span>
        </div>
        <button
          type="button"
          class="ic-btn"
          @click="openSignup"
        >
          {{ trans.get('landing.subpages_shared.cta_start_free') }}
          <span aria-hidden="true">→</span>
        </button>
      </div>

      <h2>{{ trans.get(cityKey('offerTitle')) }}</h2>
      <p>{{ trans.get(cityKey('offer')) }}</p>

      <template v-if="hasExtra">
        <h3>{{ trans.get(cityKey('extraTitle')) }}</h3>
        <p>{{ trans.get(cityKey('extra')) }}</p>
      </template>

      <div class="city-links">
        <h3>{{ trans.get('landing.subpages_shared.cta_more_cities') }}</h3>
        <p class="ck-sub">{{ trans.get('landing.subpages_shared.cta_more_cities_sub') }}</p>
        <ul>
          <li
            v-for="relatedSlug in relatedSlugs"
            :key="relatedSlug"
          >
            <a :href="`/dating-${relatedSlug}`">
              <span>{{ trans.get(`landing.cities.${relatedSlug}.title`) }}</span>
              <span class="arr">→</span>
            </a>
          </li>
        </ul>
      </div>
    </main>
  </subpage-shell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';
import { CITY_HAS_EXTRA, CITY_RELATED } from './cities.js';

export default {
  name: 'DatingCityPage',
  components: { SubpageShell },
  props: {
    slug: { type: String, required: true },
  },
  computed: {
    cityTitle() {
      return this.trans.get(`landing.cities.${this.slug}.title`);
    },
    relatedSlugs() {
      return CITY_RELATED[this.slug] || [];
    },
    hasExtra() {
      return CITY_HAS_EXTRA.has(this.slug);
    },
    hasSectionP2() {
      return this.trans.has(this.cityKey('section.p2'));
    },
  },
  methods: {
    cityKey(field) {
      return `landing.cities.${this.slug}.${field}`;
    },
    openSignup() {
      this.$eventHub.$emit('viluu-landing:open-signup', { mode: 'register' });
    },
  },
};
</script>
